import { createClient } from '@supabase/supabase-js';
import { authStorage } from './utils/authStorage.ts';

const { REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY } = process.env;

if (!REACT_APP_SUPABASE_URL || !REACT_APP_SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase env vars – check .env and restart dev server.');
}

/**
 * Same value supabase-js would pick by default, pinned here so clearLocalSession
 * can't drift away from the key the client actually writes to.
 */
const projectRef = new URL(REACT_APP_SUPABASE_URL).hostname.split('.')[0];
export const AUTH_STORAGE_KEY = `sb-${projectRef}-auth-token`;

export const supabase = createClient(
  REACT_APP_SUPABASE_URL,
  REACT_APP_SUPABASE_ANON_KEY,
  {
    auth: {
      storageKey: AUTH_STORAGE_KEY,
      persistSession: true,
      autoRefreshToken: true,
      storage: authStorage,
    },
  },
);

export const markingDb = supabase.schema('marking');
export const companyDb = supabase.schema('company_details');

/**
 * Forget the session on this origin without telling the server about it.
 *
 * The apps in this suite hand sessions to each other by transplanting the same
 * refresh token, so supabase.auth.signOut() — at *every* scope, 'local'
 * included, since they all call GoTrue's logout endpoint — would revoke the
 * session the admin or parent app is still using. Dropping the stored session
 * and reloading keeps the sign-out to this origin.
 */
export function clearLocalSession(returnTo: string): void {
  authStorage.removeItem(AUTH_STORAGE_KEY);
  window.location.replace(returnTo);
}
